export default "__VITE_ASSET__C0G$W0Ah__"